import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { Text } from "../ui/text";
import { Marquee } from "../ui/marquee";
import { AspectRatio } from "../ui/aspect-ratio";
import { TRUSTED_COMPANIES } from "@/lib/site-config";
export const TrustedBy = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Text><span className="font-bold">Trusted by</span> 2000+ companies across the globe</Text>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="from-background pointer-events-none absolute top-0 bottom-0 left-0 z-20 w-10 bg-linear-to-r to-transparent lg:w-32" />;
    t2 = <div className="from-background pointer-events-none absolute top-0 right-0 bottom-0 z-20 w-10 bg-linear-to-l to-transparent lg:w-32" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-2">{t0}<div className="relative flex items-baseline">{t1}{t2}<Marquee pauseOnHover={true} className="[--duration:50s]">{TRUSTED_COMPANIES.map(_temp)}</Marquee></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp(company, idx) {
  return <div key={idx} className="rounded-md py-2 dark:bg-white/10"><AspectRatio ratio={1.7777777777777777} className="relative h-5 w-24 max-w-32 shrink-0"><Image src={company.src} alt={company.alt} fill={true} className="object-contain dark:opacity-100 dark:brightness-0 dark:invert dark:filter" sizes="96px" priority={true} fetchPriority="high" loading="eager" /></AspectRatio></div>;
}